import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import NAVER_CLIENT_ID from '@app/constants/naverClientId';
import { modalClose } from '@app/store/modal/actions';

import './NaverLoginReAgreeModal.scss';

const propTypes = {
  isLogin: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
};

class NaverLoginReAgreeModal extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { onModalClose } = this.props;
    const redirect = `${window.location.origin}/authentication/naver-callback?windowName=${window.name}`;

    // 로그인 url 맨끝에 auth_type=reprompt를 추가하면 재동의 페이지로 연결 됨
    // https://developers.naver.com/docs/login/devguide/#5-1-5-사용자가-거부한-프로필-권한에-대하여-다시-동의를-수행하는-경우
    const href = `https://nid.naver.com/oauth2.0/authorize?client_id=${NAVER_CLIENT_ID}&response_type=token&redirect_uri=${redirect}&state=modusign&auth_type=reprompt`;

    // 재동의 팝업 열기
    window.open(
      href,
      'naverloginpop',
      'titlebar=1, resizable=1, scrollbars=yes, width=600, height=700'
    );
    onModalClose();
  }

  render() {
    const { isLogin, onModalClose } = this.props;

    return (
      <div className="Container Container--3xs tagNaverLoginReAgreeModal">
        <div className="Card Card--pop align-center box-6x">
          <h4>
            <strong>동의 필요</strong>
          </h4>
          {isLogin ? (
            <p className="space-4x">
              필수 항목을 제공하는 데 동의하지 않아
              <br />
              가입 여부를 확인할 수 없습니다.
              <br />
              동의 후 진행해 주세요.
            </p>
          ) : (
            <p className="space-4x">
              필수 항목 제공에 대한 동의가 필요합니다.
              <br />
              동의 후 진행해 주세요.
            </p>
          )}
          <button className="Btn" type="button" onClick={onModalClose}>
            취소
          </button>
          <button
            className="Btn Btn--primary NaverLoginReAgreeModal__btn"
            type="button"
            onClick={this.handleClick}
          >
            동의하러 가기
          </button>
        </div>
      </div>
    );
  }
}

NaverLoginReAgreeModal.propTypes = propTypes;

const mapDispatchToProps = {
  onModalClose: modalClose,
};

export default connect(null, mapDispatchToProps)(NaverLoginReAgreeModal);
